import {QueryObserverResult, RefetchOptions, useQueryClient} from "@tanstack/react-query";

export const useQueryResetWithRefresh = <T>(
  queryKey: Array<string | object | number | boolean | null>,
  refetch: (options?: RefetchOptions | undefined) => Promise<QueryObserverResult<T, Error>>
) => {
  const queryClient = useQueryClient()

  const resetAndRefetch = () => {
    queryClient.resetQueries({queryKey: queryKey})
    return refetch()
  }

  return { resetAndRefetch }
}